export { default } from './CategoryAdd'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Category/CategoryAdd/index.js